import { useRoutes } from "react-router-dom";
import routes from "@/Routes";
import { useSelector } from "react-redux";
import toast, { Toaster } from "react-hot-toast";
import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import { useMeta } from "./context/MetaContext";
import ScrollToTop from "./scroolToTop";
import TrackVisitor from "./components/core/TrackVisitors";

function App() {
  const { message } = useSelector((state: any) => state.message);
  const toastOptions = {
    // Define default options
    className: "",
    duration: 5000,
    style: {
      background: "#363636",
      color: "#fff",
    },

    // Default options for specific types
    success: {
      duration: 3000,
      theme: {
        primary: "green",
        secondary: "black",
      },
    },
  };

  useEffect(() => {
    if (typeof message === "string") {
      toast.success(message, toastOptions);
    }
    // Eğer message bir object ise ve error varsa error göster
    if (message && typeof message === "object" && message.errors) {
      toast.error(message.message || "An error occurred", toastOptions); // Hata mesajını göster
    }
  });
  const { meta } = useMeta();

  const generateBreadcrumbSchema = () => {
    if (!meta.breadcrumbs) return null;

    return {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: meta.breadcrumbs.map((breadcrumb, index) => ({
        "@type": "ListItem",
        position: index + 1,
        name: breadcrumb.name,
        item: breadcrumb.url,
      })),
    };
  };

  return (
    <>
      <Helmet>
        {/* Temel Meta Etiketleri */}
        <title>{meta.title}</title>
        <meta name="description" content={meta.description} />
        <meta name="keywords" content={meta.keywords.join(", ")} />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href={window.location.href} />

        {/* Open Graph Etiketleri (Facebook, LinkedIn, WhatsApp vs.) */}
        <meta property="og:title" content={meta.title} />
        <meta property="og:description" content={meta.description} />
        <meta property="og:image" content={meta.image} />
        <meta property="og:url" content={meta.url} />
        <meta property="og:type" content="website" />

        {/* Twitter Card Etiketleri */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={meta.title} />
        <meta name="twitter:description" content={meta.description} />
        <meta name="twitter:image" content={meta.image} />

        {/* JSON-LD Breadcrumbs Schema */}
        {meta.breadcrumbs && (
          <script type="application/ld+json">
            {JSON.stringify(generateBreadcrumbSchema())}
          </script>
        )}
        {meta.organizationSchema && (
          <script type="application/ld+json">
            {JSON.stringify(meta.organizationSchema)}
          </script>
        )}
      </Helmet>
      <TrackVisitor />
      <Toaster
        position="top-right"
        reverseOrder={false}
        gutter={8}
        containerClassName="mt-24"
        containerStyle={{}}
        toastOptions={toastOptions}
      />
      <ScrollToTop />
      {useRoutes(routes)}
    </>
  );
}

export default App;
